import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {AntragTicketService} from "../../../@core/services/antrag-ticket/antrag-ticket.service";
import {faPlus, faSort} from '@fortawesome/free-solid-svg-icons';
import {TranslateService} from "@ngx-translate/core";
import {nullLastComparator} from "../../../@core/utils/forms/null-last-comparator";
import {catchError} from "rxjs/operators";
import {EMPTY} from "rxjs";
import {CustomToastService} from "../../../@core/utils/custom-toast.service";
import {CompositMessageService} from "../../../@core/services/compositMessage/compositMessage.service";
import {DatePipe} from "@angular/common";
import {AntragTicketMinimalDTO} from "../../../models/antrag-ticket/AntragTicketMinimalDTO";

@Component({
  selector: 'app-ticket-table',
  templateUrl: './ticket-table.component.html',
  styleUrls: ['./ticket-table.component.scss']
})
export class TicketTableComponent implements OnInit {

  faPlus = faPlus;
  sortInitial = faSort

  public columns: any;
  public rows: any;

  datePipe : DatePipe = new DatePipe("de-DE");

  isLoading: boolean = false;
  dataFetched: boolean = false;
  entityNameTranslationKey: string = 'TICKETANTRAG';

  @ViewChild("hdrTpl", { static: true }) hdrTpl: TemplateRef<any>;

  constructor(
    private router: Router,
    private antragTicketService: AntragTicketService,
    public translate: TranslateService,
    private customToastService: CustomToastService,
    private compositMessageService: CompositMessageService
  ) {}

  ngOnInit(): void {

    this.columns = [
      { name: 'name', headerTemplate: this.hdrTpl, comparator: nullLastComparator.bind(this) },
      { name: 'vorname', headerTemplate: this.hdrTpl , maxWidth: 150, comparator: nullLastComparator.bind(this) },
      { name: 'schule', headerTemplate: this.hdrTpl , prop: 'schuleName', comparator: nullLastComparator.bind(this) },
      { name: 'schuljahr', headerTemplate: this.hdrTpl , prop: 'schuljahrName', maxWidth: 120, comparator: nullLastComparator.bind(this)},
      { name: 'antragsdatum', headerTemplate: this.hdrTpl , maxWidth: 130 , pipe: this.translateDatePipe(), comparator: nullLastComparator.bind(this) },
      { name: 'status', headerTemplate: this.hdrTpl, pipe: this.translatePipe(), comparator: nullLastComparator.bind(this) }
    ];

    this.isLoading = true;
    this.dataFetched = false;
    this.antragTicketService.getAllAntraegeMinimal()
      .pipe(
        catchError((err) => {
          this.customToastService.showError(this.compositMessageService.createErrorMessage(err,this.entityNameTranslationKey,'getBulk'));
          this.isLoading   = false;
          this.dataFetched = null;
          return EMPTY;
        })
      )
      .subscribe((data: Array<AntragTicketMinimalDTO>) => {
        this.rows = data;
        this.isLoading = false;
        this.dataFetched = this.rows.length>0;
      });
  }

  onActivate(event) {
    if(event.type == 'click') {
      this.router.navigate(['/pages/ticket-detail/'+event.row.id ]).catch(()=>{});
    }
  }

  translatePipe () {
    return {transform: (value) => this.translate.instant('TICKET-TABLE.STATUS.'+value)};
  }

  translateDatePipe () {
    return {transform: (value) => this.datePipe.transform(value, 'dd.MM.yyyy')};
  }

}

